import { createFormAction } from "redux-form-saga";
export const FORM_KEY = "SYSTEM_PRICE_FORM";
export const SystemPriceFormAction = createFormAction(FORM_KEY);
